import React from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import style from "./MarketSection.module.css";

function MarketSection(props) {
  return (
    <>
    <div className={style.content} style={{background: `url(${props.bgImage})`}} id={props.sectionId}>
        <div className={style.contentTitle}>
            <h2>{props.title}</h2>
        </div>
        <div className={style.contentTexts}>
            <h3>{props.subTitle}</h3>
            <p>{props.text}</p>
        </div>
        <div className={style.contentBtn}>
            <a href={`${global.config.baseUrl}/comingsoon/marketplace`} type="button" disabled>Visit Marketplace</a>
        </div>
    </div>
    </>
  )
}

export default MarketSection